export default "__VITE_ASSET__DW6GF9w___"